import { FC } from "react";
import { useModal } from "@refinedev/antd";
import { useDelete, useNavigation } from "@refinedev/core";
import { Button, Modal } from "antd";
import { DeleteOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

import { tvErrorNotification, tvSuccessNotification } from "../Lib";

type Props = {
  resource: string;
  id: number;
  name: string;
  entityAccusative: string;
  /** Куда уйти после удаления; не задано — остаёмся (удаление из списка). */
  redirectPath?: string;
  size?: "small" | "middle";
  onDeleted?: () => void;
  /**
   * Автовидео: бэкенд его не удаляет, а скрывает (удалённое перенос завёл бы снова),
   * поэтому и кнопка — «Скрыть».
   */
  hide?: boolean;
};

export const TvDelete: FC<Props> = ({
  resource,
  id,
  name,
  entityAccusative,
  redirectPath,
  size = "small",
  onDeleted,
  hide = false,
}) => {
  const { modalProps, show, close } = useModal();
  const { mutate, isLoading } = useDelete();
  const { push } = useNavigation();

  const handleDelete = () =>
    mutate({
      dataProviderName: "tvDataProvider",
      resource,
      id,
      ...tvSuccessNotification(
        `«${name}» ${hide ? "скрыто" : "удалено"}`,
        () => {
          close();
          onDeleted?.();
          if (redirectPath) push(redirectPath);
        }
      ),
      ...tvErrorNotification(hide ? "Не удалось скрыть" : "Не удалось удалить"),
    });

  return (
    <>
      <Button
        size={size}
        danger={!hide}
        block
        onClick={show}
        icon={hide ? <EyeInvisibleOutlined /> : <DeleteOutlined />}
      >
        {hide ? "Скрыть" : "Удалить"}
      </Button>
      <Modal
        {...modalProps}
        title="Подтверждение"
        okText={hide ? "Скрыть" : "Удалить"}
        cancelText="Отмена"
        okButtonProps={{ danger: !hide, loading: isLoading }}
        onOk={handleDelete}
        onCancel={close}
      >
        {hide
          ? `Скрыть ${entityAccusative} «${name}» с сайта? Перенесённое автоматически видео не удаляется: перенос завёл бы его снова. Вернуть на сайт — статусом «Опубликовано».`
          : `Удалить ${entityAccusative} «${name}»?`}
      </Modal>
    </>
  );
};
